export enum Routenames {
    addressArea = 'address-area',
    answers = 'answers',
    airtable = 'commerciele-kaart-opdrachtgevers',
    addresses = 'adressen',
    chat = 'chat',
    code = 'code',
    consumers = 'consumers',
    contacts = 'contacts',
    copy = 'copy',
    documents = 'documents',
    drillingProjects = 'drilling-projects',
    edit = 'edit',
    entra = 'entra',
    future = 'future',
    importExcel = 'import-excel',
    importShapefile = 'import-shapefile',
    list = 'list',
    login = 'inloggen',
    logout = 'logout',
    newItem = 'new',
    news = 'news',
    projects = 'projects',
    qr = 'qr',
    register = 'register',
    report = 'report',
    requestAccess = 'request-access',
    settings = 'settings',
    survey = 'survey',
    table = 'table',
    takeOver = 'take-over',
    timeline = 'timeline',
    customers = 'customers',
    customersScreenshot = 'customers-screenshot',
    users = 'users',
    workareas = 'workareas',
}
